import script from "./StripeInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./StripeInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./StripeInvoice.vue?vue&type=style&index=0&id=c4b2622e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4b2622e"]])

export default __exports__